import 'whatwg-fetch';
import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import {
	parseJSON, 
	isOk, 
} from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/

export function setJewelryFilters(filters) {
  return {
    type: constants.JEWELRY_FILTER_SAVE,
    filters
  };
}

export function jewelrySave(jewelry, count = 0) {
	return {
    type: constants.JEWELRY_SAVE,
    jewelry,
    count,
  };
}

export function jewelrySaveSelected(jewelry) {
	return {
    type: constants.JEWELRY_SAVE_SELECTED,
    jewelry,
  };
}

export function jewelrySetLastPosition(scrollPos) {
	return {
    type: constants.JEWELRY_SET_LAST_POSITION,
    scrollPos,
  };
}

export function jewelryToggleListView() {
	return {
    type: constants.JEWELRY_TOGGLE_LIST,
  };
}



/******************************
*******  Asynchronous  ********
******************************/




export function fetchJewelry(jewelryFilters, page) {

	return dispatch => {

		let first = true;
		let getParams = '';

		const pageInt = parseInt(page);
		const PAGE_SIZE = 100;
		const pagination = {
			limit: PAGE_SIZE,
			offset: PAGE_SIZE*(pageInt - 1),
		}

		let pageFilters = Object.assign({}, jewelryFilters, pagination);

		let filterKeys = Object.keys(pageFilters);
		for(let i = 0; i < filterKeys.length; i++) {

			if(first) {
				getParams = '?' + filterKeys[i] + '=' + pageFilters[filterKeys[i]];
			} else {
				getParams += '&' + filterKeys[i] + '=' + pageFilters[filterKeys[i]];
			}
			first = false;
		}
		let encodedParams = encodeURI(getParams);

		let url = api.PRODUCT_API_URL + endpoint.PRODUCT_JEWELRY_FETCH_LIST + encodedParams;
		return fetch(url, {
		  method: 'get',
		  headers: api.HEADERS,
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data.success);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

// export function productFetchBySku(settingSku) {
//   return dispatch => {
//     let url = api.PRODUCT_API + endpoint.PRODUCT_SETTING_BY_SKU + '?sku=' + settingSku;
//     return fetch(url, {
//       method: 'get',
//       headers: api.HEADERS
//     })
//     .then(parseJSON)
//     .then((resp) => {
//       if(isOk(resp.status)) {
//         return Promise.resolve(resp.data);
//       } else {
//         return Promise.reject(resp.data);
//       }
//     });
//   }
// }

// export function productFetchSearchResults(searchTerm, sortVal='') {
//   return dispatch => {
//     let url = api.PRODUCT_API + endpoint.PRODUCT_SEARCH + '?q=' + encodeURIComponent(searchTerm);
//     if(sortVal) {
//       url = url + '&sort=' + sortVal;
//     }
//     return fetch(url, {
//       method: 'get',
//       headers: api.HEADERS
//     })
//     .then(parseJSON)
//     .then((resp) => {
//       if(isOk(resp.status)) {
//         return Promise.resolve(resp.data);
//       } else {
//         return Promise.reject(resp.data);
//       }
//     });
//   }
// }

export function fetchJewelryByAscId(ascId) {

	return dispatch => {
		let url = api.PRODUCT_API_URL + endpoint.PRODUCT_JEWELRY_SIMPLE_SKU + '?sku=' + ascId;
		return fetch(url, {
		  method: 'get',
		  headers: api.HEADERS,
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function fetchJewelryByBarcodeId(barcodeId) {

	return dispatch => {
		const url = api.PRODUCT_API_URL + endpoint.PRODUCT_JEWELRY_BARCODE_LOOKUP + `?barcode_id=${barcodeId || ''}`;
		return fetch(url, {
		  method: 'get',
		  headers: api.HEADERS,
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}
